<div
  class="media-preview"
  (pointerdown)="onBackdropPointerDown($event)"
  (pointerup)="onBackdropPointerUp($event)"
  (pointercancel)="onBackdropPointerCancel()"
>
  <div
    class="preview-toolbar"
    (click)="stopPropagation($event)"
    (pointerdown)="stopPropagation($event)"
    (pointerup)="stopPropagation($event)"
  >
    @if (is_image()) {
      <label class="zoom-control">
        <mat-icon aria-hidden="true">zoom_in</mat-icon>
        <input
          type="range"
          min="100"
          max="200"
          step="1"
          [value]="zoom_percent()"
          (input)="onZoomInput($event)"
          (click)="stopPropagation($event)"
          (pointerdown)="stopPropagation($event)"
          (pointerup)="stopPropagation($event)"
          aria-label="Zoom de la imagen"
        />
        <span class="zoom-label">{{ zoom_percent() }}%</span>
      </label>
      <button
        mat-icon-button
        type="button"
        class="toolbar-btn"
        (click)="copyImage($event)"
        [disabled]="copying()"
        aria-label="Copiar imagen"
      >
        <mat-icon>content_copy</mat-icon>
      </button>
      <button
        mat-icon-button
        type="button"
        class="toolbar-btn"
        (click)="downloadImage($event)"
        [disabled]="downloading()"
        aria-label="Descargar imagen"
      >
        <mat-icon>download</mat-icon>
      </button>
    }
    <button mat-icon-button type="button" class="toolbar-btn" (click)="closeFromButton($event)" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  @if (show_unsupported_playback()) {
    <div class="unsupported-media" (click)="stopPropagation($event)">
      <mat-icon>{{ unsupported_icon() }}</mat-icon>
      <p>{{ unsupported_message() }}</p>
      <a
        mat-flat-button
        color="accent"
        [href]="download_href()"
        [download]="download_file_name()"
        target="_blank"
        rel="noopener"
        (click)="onDownloadClick($event)"
      >
        {{ download_label() }}
      </a>
    </div>
  } @else if (is_video()) {
    <video [src]="src()" controls autoplay playsinline (click)="stopPropagation($event)" (error)="onPlaybackError()"></video>
  } @else if (is_audio()) {
    <div class="audio-preview" (click)="stopPropagation($event)">
      <audio [src]="src()" controls autoplay (error)="onPlaybackError()"></audio>
    </div>
  } @else {
    <div #imageViewport class="image-viewport" (wheel)="onImageWheel($event)">
      <div class="image-stage">
        <img
          #previewImage
          class="preview-image"
          [class.preview-image--sized]="image_width_style() !== null"
          [class.preview-image--transition]="width_transition()"
          [style.width]="image_width_style()"
          [style.cursor]="image_cursor()"
          [src]="src()"
          [alt]="image_alt()"
          draggable="false"
          (load)="onImageLoad($event)"
          (click)="onImageClick($event)"
        />
      </div>
    </div>
  }
</div>
